export const TRANSFERIR_FORM_ID = "transferir-escopo-macro-form";

export const TRANSFERIR_TITLE = "Transferir Escopo macro";
export const SERVICOS_MATERIAIS_TITLE = "Serviços e Materiais do escopo macro";
export const ESCOPO_ROTULO = "Escopo macro em transferência";
export const CARREGANDO_LABEL = "Carregando Obras de destino...";

export const ETAPAS_LABEL = "Etapas da transferência";
export const ETAPA_DESTINO = "Destino";
export const ETAPA_REVISAO = "Revisão";

export const CANCELAR_LABEL = "Cancelar";
export const VOLTAR_LABEL = "Voltar";
export const PROXIMA_LABEL = "Próxima etapa";
export const TRANSFERIR_LABEL = "Transferir Escopo macro";

export const DESTINO_TITLE = "Obra de destino";
/** Figma 13049:596; o Tipo vem com hífen (`103 - Parada Programada`). */
export const DESTINO_SUBTITLE = (tipoObra: string) =>
  `Escolha a Obra que vai receber o escopo macro. Ele entra no mesmo Tipo de Obra da origem: ${tipoObra}.`;
/** Figma 12415:606272 (lista-obras-mesma-embarcacao). */
export const MS01 = (embarcacao: string, obra: string, tipoCodigo: string) =>
  `Só aparecem Obras da ${embarcacao}, sem a atual (${obra}). Obra sem o ${tipoCodigo} fica indisponível até você adicionar esse Tipo de Obra nela.`;
// Pendência de texto (PO): a HU traz a MS02 com a embarcação, sem o texto final do Figma revisado.
export const MS02 = (embarcacao: string) =>
  `A embarcação ${embarcacao} não tem outras Obras abertas. Para transferir, primeiro crie a Obra de destino no Nova Obra.`;
export const INDISPONIVEL_LABEL = "Indisponível";
// Pendência de texto (PO): a HU não define a mensagem da Obra disponível sem centro de custo receptor.
export const DESTINO_OBRIGATORIO = "Selecione a Obra de destino.";
export const CENTRO_CUSTO_OBRIGATORIO = "Selecione o centro de custo de destino.";
export const ACEITE_OBRIGATORIO =
  "Marque Concordo para transferir com o término depois do fim da Obra.";
export const TRANSFERIR_PENDENCIAS = "Resolva os avisos acima para transferir.";
export const SEM_CENTRO_CUSTO =
  "Esta Obra não tem centro de custo receptor para o Tipo de Obra do Escopo Macro.";
export const EMBARCACAO_NAO_INFORMADA = "sem embarcação";

export const TABELA_LABEL = "Obras da mesma embarcação";
export const COLUNA_ID = "ID";
export const COLUNA_STATUS = "Status Financeiro";
export const COLUNA_TIPOS = "Tipos de Obra";
export const COLUNA_CONDICAO = "Condição";
export const COLUNA_INICIO = "Início";
export const COLUNA_TERMINO = "Término";
export const COLUNA_OUTLOOK = "Outlook BRL M";
export const COLUNA_SITUACAO = "Situação";
export const SITUACAO_DISPONIVEL = "Disponível";

export const CENTRO_CUSTO_LABEL = "Centro de custo de destino";
export const CENTRO_CUSTO_PLACEHOLDER = "Selecione o centro de custo";

export const REVISAO_TITLE = "Revisão";
export const REVISAO_SUBTITLE =
  "Confira de onde sai e para onde vai o escopo macro e as datas calculadas no destino.";
export const SAI_DE = "Sai de";
export const VAI_PARA = "Vai para";
export const OBRA_LABEL = "Obra";
export const EMBARCACAO_LABEL = "Embarcação";
export const TIPO_OBRA_LABEL = "Tipo de Obra";
export const CENTRO_CUSTO_REVISAO_LABEL = "Centro de custo";

export const DATAS_TITLE = "Datas no destino";
export const DATAS_COLUNA_PERIODO = "Período";
export const DATAS_COLUNA_INICIO = "Início";
export const DATAS_COLUNA_TERMINO = "Término";
export const DATAS_COLUNA_DURACAO = "Duração";
export const DATAS_ORIGEM = (escopo: string, obra: string) => `${escopo} na Obra ${obra} (origem)`;
export const DATAS_DESTINO = (escopo: string, obra: string) =>
  `${escopo} na Obra ${obra} (destino)`;
export const DATAS_OBRA = (obra: string) => `Obra ${obra}`;
export const DURACAO_DIAS = (dias: number) => `${dias} dias`;
// Nota 2 (D4): sem início no destino não há como posicionar as datas.
export const SEM_INICIO_DESTINO_AVISO =
  "A Obra de destino não tem data de início; não é possível posicionar as datas do Escopo Macro.";
/** Figma 17019:877889 (message-datas). */
export const POSICIONAMENTO_AVISO = (obra: string, inicio: string, dias: number) =>
  `O início do escopo macro foi posicionado no início da Obra ${obra} (${inicio}) e a duração de ${dias} dias se mantém. Depois da transferência efetivada, as datas podem ser alteradas pela Obra ${obra}.`;
/** Figma 17019:877889 (alerta-duracao). */
export const FORA_PERIODO_AVISO = (escopo: string, dias: number, obra: string, termino: string) =>
  `O ${escopo} dura ${dias} dias e passa do término da Obra ${obra} (${termino}). A transferência pode seguir, mas o escopo macro fica com pendência de duração até o período caber na Obra ${obra}. Para seguir, clique em Concordo.`;
export const CONCORDO_LABEL = "Concordo";

export const PROJECAO_AVISO =
  "A revisão da projeção financeira será feita quando a projeção estiver disponível.";

export const CONFIRMAR_TITLE = "Transferir Escopo macro";
/** Figma 12415:939392: código e nome da Obra de destino; o Tipo com hífen. */
export const MS03 = (obra: string, tipo: string) =>
  `Tem certeza de que deseja transferir este escopo macro para a ${obra}, no Tipo de Obra ${tipo}?`;

/** Figma 12415:953839. */
export const ENVIADO_PARA_APROVACAO = (escopo: string) =>
  `Solicitação de transferência do ${escopo} enviada para aprovação.`;
/** Figma 16777:487710 (FEL 0, efetivada na hora). */
export const TRANSFERIDO_MESSAGE = "Escopo macro transferido com sucesso.";
